<template>
  <footer class="footer-container">
    <div class="footer-content">
      <div class="footer-layout">
        <!-- 前四列部分 -->
        <div class="left-section">
          <div class="footer-columns">
            <!-- 第一列：关于我们 -->
            <div class="footer-column">
              <h3 class="column-title">关于我们</h3>
              <ul class="column-list">
                <li class="list-item" @click="pushRoute('/about#jianjie')">公司简介</li>
                <li class="list-item" @click="pushRoute('/about#jingying')">经营范围</li>
                <li class="list-item" @click="pushRoute('/about#yingyong')">应用领域</li>
                <li class="list-item" @click="pushRoute('/about#qiye')">企业文化</li>
              </ul>
            </div>

            <!-- 第二列：产品中心 -->
            <div class="footer-column">
              <h3 class="column-title">产品中心</h3>
              <ul class="column-list">
                <li class="list-item" @click="pushRoute('/product/ganggu')">钢骨架聚乙烯塑料复合管</li>
                <li class="list-item" @click="pushRoute('/product/duochong')">多重增强钢塑复合管</li>
                <li class="list-item" @click="pushRoute('/product/kongwang')">孔网钢带聚乙烯复合管</li>
                <li class="list-item" @click="pushRoute('/product/kongwang-pert')">PE-RT耐热孔网钢带复合管</li>
                <li class="list-item" @click="pushRoute('/product/pe')">PE管</li>
                <li class="list-item" @click="pushRoute('/product/gangsiwang')">钢丝网骨架聚乙烯复合管</li>
                <li class="list-item" @click="pushRoute('/product/boxian')">玻纤双高筋增强聚乙烯缠绕管</li>
                <li class="list-item" @click="pushRoute('/product/kela')">克拉管、高密度聚乙烯缠绕结构壁B型管</li>
              </ul>
            </div>

            <!-- 第三列：工程案例 -->
            <div class="footer-column">
              <h3 class="column-title">工程案例</h3>
              <ul class="column-list">
<!--                <li class="list-item">案例一</li>-->
              </ul>
            </div>

            <!-- 第四列：联系我们 -->
            <div class="footer-column contact-column">
              <h3 class="column-title">联系我们</h3>
              <div class="contact-info">
                <div class="contact-item">
                  <div class="contact-label">联系电话：</div>
                  <div class="phone-numbers">
                    <div class="phone-number">13050915030</div>
                    <div class="phone-number">13050915032</div>
                  </div>
                </div>
                <div class="contact-item">
                  <div class="contact-label">联系地址：</div>
                  <div class="contact-detail">辽宁省朝阳县柳城经济开发区</div>
                </div>
                <div class="contact-item">
                  <div class="contact-label">邮箱：</div>
                  <div class="contact-detail">qingshanxincailiao@163.com</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 二维码部分 -->
        <div class="right-section">
          <div class="qrcode-container">
            <div class="qrcode-image">
              <div class="qrcode-placeholder">
                <div class="qr-inner"></div>
              </div>
            </div>
            <div class="qrcode-text">微信客服</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 版权信息 -->
    <div class="copyright-section">
      <div class="copyright-divider"></div>
      <div class="copyright-text">
        朝阳青山新材料科技有限公司
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  data() {
    return {
      // 这里可以添加数据
    }
  },
  methods: {
    pushRoute(path) {
      // 如果当前已经在 about 页面，直接滚动到指定位置
      if (this.$route.path === '/about' && path.includes('#')) {
        const elementId = path.split('#')[1];
        const element = document.getElementById(elementId);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      } else {
        // 否则使用路由跳转，让路由的 scrollBehavior 处理
        this.$router.push(path);
      }
    }
  }
}
</script>

<style scoped>
/* 主色调：深灰色背景，白色文字 */
.footer-container {
  width: 100%;
  background-color: #1a1a1a;
  color: #fff;
  font-family: "PingFang SC", "Microsoft YaHei", "Helvetica Neue", Arial, sans-serif;
  padding: 40px 0 20px;
  box-sizing: border-box;
}

.footer-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 整体布局：左边是前四列，右边是二维码 */
.footer-layout {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

/* 左边前四列部分 */
.left-section {
  flex: 0 0 calc(100% - 600px); /* 占大部分宽度 */
  max-width: calc(100% - 200px);
}

.footer-columns {
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  gap: 0px; /* 前四列之间紧凑的间距 */
}

.footer-column {
  flex: 1;
  min-width: 0;
}

.column-title {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 15px;
  color: #fff;
  position: relative;
  padding-bottom: 8px;
}

.column-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 30px;
  height: 2px;
  background-color: #1fb53a;
}

.column-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.list-item {
  margin-bottom: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
  color: #ccc;
  line-height: 1.4;
}

.list-item:hover {
  color: #1fb53a;
  transform: translateX(3px);
}

/* 联系我们列样式 */
.contact-column {
  flex: 1.2;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  line-height: 1.4;
  white-space: nowrap;
}

.contact-label {
  font-weight: 500;
  font-size: 14px;
  color: #fff;
  min-width: 70px;
  flex-shrink: 0;
  margin-right: 5px;
}

.phone-numbers {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.phone-number {
  font-family: "SF Mono", "Roboto Mono", Consolas, monospace;
  font-size: 14px;
  color: #ccc;
  font-weight: 500;
}

.contact-detail {
  font-size: 14px;
  color: #ccc;
  flex: 1;
  white-space: nowrap;
}

/* 右边二维码部分 */
.right-section {
  flex: 0 0 180px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  margin-left: 150px; /* 增加左边距，与前四列保持距离 */
}

.qrcode-container {
  text-align: center;
  width: 100%;
}

.qrcode-image {
  width: 150px;
  height: 150px;
  background: #f8f8f8;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 10px;
  overflow: hidden;
  position: relative;
  border: 1px solid #333;
}

.qrcode-placeholder {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}

.qr-inner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  height: 80%;
  //background:
  //    linear-gradient(45deg, transparent 45%, #1fb53a 45%, #1fb53a 55%, transparent 55%),
  //    linear-gradient(-45deg, transparent 45%, #1fb53a 45%, #1fb53a 55%, transparent 55%),
  //    linear-gradient(45deg, transparent 45%, #1fb53a 45%, #1fb53a 55%, transparent 55%),
  //    linear-gradient(-45deg, transparent 45%, #1fb53a 45%, #1fb53a 55%, transparent 55%);
  background-image: url("../assets/img/客服.png");
  background-repeat: no-repeat;
  background-size: 120px 120px;
  background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
  //opacity: 0.3;
}

.qrcode-text {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  margin: 0;
}

/* 版权信息部分 */
.copyright-section {
  max-width: 1400px;
  margin: 30px auto 0;
  padding: 0 20px;
}

.copyright-divider {
  height: 1px;
  background-color: #333;
  margin-bottom: 15px;
}

.copyright-text {
  text-align: center;
  font-size: 12px;
  color: #999;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .footer-content {
    padding: 0 15px;
  }

  .left-section {
    flex: 0 0 calc(100% - 180px);
    max-width: calc(100% - 180px);
  }

  .right-section {
    flex: 0 0 160px;
    margin-left: 30px;
  }

  .footer-columns {
    gap: 8px;
  }
}

@media (max-width: 992px) {
  .footer-layout {
    flex-direction: column;
  }

  .left-section {
    flex: 0 0 100%;
    max-width: 100%;
    margin-bottom: 30px;
  }

  .right-section {
    flex: 0 0 auto;
    margin-left: 0;
    width: 100%;
    justify-content: center;
  }

  .footer-columns {
    flex-wrap: wrap;
    gap: 25px;
  }

  .footer-column {
    flex: 0 0 calc(33.333% - 17px);
    min-width: auto;
  }

  .contact-column {
    flex: 0 0 calc(50% - 12px);
  }
}

@media (max-width: 768px) {
  .footer-container {
    padding: 30px 0 20px;
  }

  .footer-columns {
    gap: 20px;
  }

  .footer-column {
    flex: 0 0 calc(50% - 10px);
  }

  .contact-column {
    flex: 0 0 100%;
  }

  .column-title {
    font-size: 15px;
    margin-bottom: 12px;
  }

  .list-item {
    font-size: 13px;
    margin-bottom: 8px;
  }

  .contact-info {
    gap: 10px;
  }

  .contact-label {
    font-size: 13px;
    min-width: 60px;
  }

  .phone-number,
  .contact-detail {
    font-size: 13px;
  }

  .qrcode-image {
    width: 90px;
    height: 90px;
  }

  .qrcode-text {
    font-size: 13px;
  }

  .copyright-section {
    margin-top: 20px;
    padding: 0 15px;
  }
}

@media (max-width: 480px) {
  .footer-container {
    padding: 25px 0 15px;
  }

  .footer-content {
    padding: 0 10px;
  }

  .footer-columns {
    flex-direction: column;
    gap: 25px;
  }

  .footer-column {
    flex: 0 0 100%;
  }

  .contact-item {
    flex-direction: column;
    align-items: flex-start;
    white-space: normal;
  }

  .contact-label {
    margin-bottom: 3px;
  }

  .contact-detail {
    white-space: normal;
  }
}
</style>